import reduxStore from "../../../../../configureEnvStore";
import { ERROR_TYPE } from "../../../../../constants/CallSettingConstants";
import {
    setAgentVideoSubscriptionFailed,
    setForLocalRemoteCheck,
    setVideoFailedInDeviceType,
    setVideoFailedUserNumber,
} from "../../../../../reducers/track-failed-reducer";
import { setAudioError, setAudioErrorModal } from "../../../../../reducers/twilioEvents-reducer";
import { checkVideoSupport, getParticipantIndex } from "../../../../../shared/dataTrackFunction";

export const handleTrackSubscriptionFailed = (_error, track, fromwhere) => {
    if (track.kind == "video") {
        checkVideoSupport(fromwhere);
    }
    if (track.kind == "audio") {
        checkAudioSupport(fromwhere);
    }
};

const checkAudioSupport = (fromwhere) => {
    reduxStore.dispatch(setAudioError(ERROR_TYPE.TRACK_SUBSCRIPTION_FAILED));
    reduxStore.dispatch(setForLocalRemoteCheck(fromwhere));
    reduxStore.dispatch(setAudioErrorModal(true));
};

export const showAgentVideoSubscriptionFailed = (msg) => {
    const { videoFailedUserNumber } = reduxStore.getState().trackFailed;
    reduxStore.dispatch(setVideoFailedInDeviceType(msg.device_type));

    const participantIndex = getParticipantIndex(msg.identity);
    if (videoFailedUserNumber !== "") {
        reduxStore.dispatch(setVideoFailedUserNumber(videoFailedUserNumber + " & " + participantIndex));
    } else {
        reduxStore.dispatch(setVideoFailedUserNumber(participantIndex));
    }
    reduxStore.dispatch(setAgentVideoSubscriptionFailed(true));
};
